var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.937 5.971C3.875 7.061 3.104 8.431 2.733 9.959",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29001 20.443C9.88101 20.571 10.494 20.642 11.124 20.642C12.016 20.642 12.877 20.506 13.687 20.255",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.734 14.041C3.105 15.569 3.876 16.939 4.938 18.029",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.405 14.464C18.986 15.876 18.212 17.133 17.193 18.142",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.193 5.85799C18.212 6.86699 18.985 8.12399 19.405 9.53599",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29001 3.557C9.88101 3.429 10.494 3.358 11.124 3.358C12.016 3.358 12.877 3.494 13.687 3.745",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5338 10.2322C22.5101 11.2085 22.5101 12.7914 21.5338 13.7677C20.5575 14.744 18.9746 14.744 17.9983 13.7677C17.022 12.7914 17.022 11.2085 17.9983 10.2322C18.9746 9.25588 20.5575 9.25588 21.5338 10.2322",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82677 17.5692C9.80308 18.5455 9.80308 20.1284 8.82677 21.1047C7.85046 22.081 6.26755 22.081 5.29124 21.1047C4.31493 20.1284 4.31493 18.5455 5.29124 17.5692C6.26755 16.5929 7.85046 16.5929 8.82677 17.5692",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82677 2.89523C9.80308 3.87154 9.80308 5.45445 8.82677 6.43076C7.85046 7.40707 6.26755 7.40707 5.29124 6.43076C4.31493 5.45445 4.31493 3.87154 5.29124 2.89523C6.26755 1.91892 7.85046 1.91892 8.82677 2.89523",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.2b4d297542a08cd2c00f37a205325420.svg";
export { ForwardRef as ReactComponent };